import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { ShoppingCartLineV2, ShoppingCartV2 } from '@api/ShoppingCart/ShoppingCartV2';
import { getOrderLineDisplay } from '@utils/Order';
import { currencyFormatter } from '@utils/Numbers';

interface CartLineListProps {
    shoppingCart?: ShoppingCartV2;
    onEditLine: (line: ShoppingCartLineV2) => void;
    onRemoveLine: (index: number) => void;
}

// Carrito 2.0: a diferencia del v1, muestra los modificadores y los "sin X" de cada línea
// (usando el renderer dual) — el cajero ve exactamente lo que va a salir en el ticket.
//
// D3 (2026-08-27): esta lista se quedó SOLO con productos. La promoción aplicada y
// el botón de envío vivían aquí abajo y se iban con el scroll en cuanto había
// varios productos; ahora son chips en `OrderActionsBar`, en la zona fija.
export const CartLineList: React.FC<CartLineListProps> = ({ shoppingCart, onEditLine, onRemoveLine }) => {
    return (
        // ZONA FLEX del panel (D2): `minHeight: 0` es lo que le permite ENCOGERSE
        // y scrollear en vez de empujar al resumen fuera de la pantalla.
        <Stack flex={1} minHeight={0} spacing={2} overflow="auto">
            {shoppingCart?.products?.map((cartLine, index) => {
                const line = getOrderLineDisplay(cartLine);
                return (
                    <Stack key={index} direction="row" alignItems="flex-start" justifyContent="space-between">
                        <Stack flex={1} minWidth={0}>
                            <Typography variant="body1" fontWeight={600}>
                                {`${line.quantity}x ${line.name}`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {line.takeAway ? 'Para llevar' : 'Para mostrador'}
                            </Typography>
                            {line.modifiers.map((modifier, idx) => (
                                <Typography key={idx} variant="caption" color="text.secondary">
                                    + {modifier.quantity}x {modifier.optionName || modifier.label}
                                    {modifier.extraCostTotal > 0 ? ` (+${currencyFormatter(modifier.extraCostTotal)})` : ''}
                                </Typography>
                            ))}
                            {line.removedIngredients.length > 0 && (
                                <Typography variant="caption" color="error.main" fontStyle="italic">
                                    Sin: {line.removedIngredients.join(', ')}
                                </Typography>
                            )}
                            {line.note && (
                                <Typography variant="caption" fontStyle="italic">
                                    Nota: {line.note}
                                </Typography>
                            )}
                        </Stack>
                        <Stack direction="row" alignItems="center">
                            <IconButton onClick={() => onEditLine(cartLine)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => onRemoveLine(index)}>
                                <DeleteIcon />
                            </IconButton>
                            <Typography width={100} variant="body1" textAlign="center" fontWeight={600}>
                                {currencyFormatter(line.total)}
                            </Typography>
                        </Stack>
                    </Stack>
                );
            })}

        </Stack>
    );
};
